import React, { useEffect, useState } from "react";
import { api } from "../../lib/api.js";
import { PageHead, Notice, fmtWhen } from "./ui.jsx";
import { useConfirm } from "../ConfirmDialog.jsx";

export default function AccessPage({ isAdmin }) {
  const [grants, setGrants] = useState([]);
  const [f, setF] = useState({ email: "", role: "agent", displayName: "" });
  const [msg, setMsg] = useState(null);
  const [dialog, ask] = useConfirm();
  const load =async () => { try { setGrants((await api("/backoffice/access")).grants); } catch { /* admin only */ } };
  useEffect(() => { load(); }, []);
  async function add(e) {
    e.preventDefault(); setMsg(null);
    try { await api("/backoffice/access", { method: "POST", body: f }); setF({ email: "", role: "agent", displayName: "" }); await load(); setMsg("Saved. They use the guest or partner sign-in with that email, and land on their screen."); }
    catch (err) { setMsg(err.message); }
  }
  async function remove(g) {
    if (!(await ask({ title: `Remove ${g.displayName}'s access?`, body: "They will no longer see their screen after signing in.", confirmLabel: "Remove access" }))) return;
    try { await api(`/backoffice/access/${g.id}`, { method: "DELETE" }); await load(); } catch (err) { setMsg(err.message); }
  }
  return (
    <>
      <PageHead title="Access for people outside Lipari" sub="Lipari staff get access through IT. Anyone else, the travel agent above all, gets it here by email: they sign in with the guest or partner sign-in and see only their screen." />
      {isAdmin && (
        <form className="bo-panel bo-field-grid three" onSubmit={add}>
          <label className="bo-field">Name<input type="text" value={f.displayName} onChange={e => setF({ ...f, displayName: e.target.value })} required /></label>
          <label className="bo-field">Email<input type="email" value={f.email} onChange={e => setF({ ...f, email: e.target.value })} required /></label>
          <label className="bo-field">Role<select value={f.role} onChange={e => setF({ ...f, role: e.target.value })}>
            <option value="agent">Travel agent: codes, check a code, mark booked</option>
            <option value="view-only">View only</option>
          </select></label>
          <div className="bo-drawer-actions"><button className="bo-btn primary" type="submit">Give access</button></div>
        </form>
      )}
      {msg && <Notice tone="ok">{msg}</Notice>}
      {dialog}
      <div className="bo-table access">
        <div className="bo-th"><div>Name</div><div>Email</div><div>Role</div><div>Since</div><div /></div>
        {grants.map(g => (
          <div className="bo-tr" key={g.id}><div><b>{g.displayName}</b></div><div className="mono">{g.email}</div><div>{g.role}</div><div className="muted">{fmtWhen(g.createdAt)}</div><div className="actions">{isAdmin && <button className="bo-link" onClick={() => remove(g)}>Remove</button>}</div></div>
        ))}
        {!grants.length && <div className="bo-empty">Nobody outside Lipari has access yet.</div>}
      </div>
    </>
  );
}
